import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { Grid } from "@mui-wrapper";
import { LINK_HEIGHT, SelectWorkspaceLink } from "@components/common/workspace/select-workspace-link";
/**
 * Shows a single workspace to be selected in the workspaces selection page.
 */
export function SelectWorkspaceItem(t0) {
  const $ = _c(14);
  const {
    sdbCompany,
    isEven: t1,
    onWorkspaceClick
  } = t0;
  const isEven = t1 === undefined ? false : t1;
  const t2 = isEven ? "10px" : "0px";
  let t3;
  if ($[0] !== t2) {
    t3 = {
      xs: "0px",
      md: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = isEven ? "0px" : "10px";
  let t5;
  if ($[2] !== t4) {
    t5 = {
      xs: "0px",
      md: t4
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t3 || $[5] !== t5) {
    t6 = {
      paddingRight: t3,
      paddingLeft: t5,
      paddingBottom: "20px"
    };
    $[4] = t3;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      xs: 12,
      md: 6
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== onWorkspaceClick || $[9] !== sdbCompany) {
    t8 = sdbCompany ? <SelectWorkspaceLink sdbCompany={sdbCompany} onClick={onWorkspaceClick} /> : <Skeleton variant="rectangular" height={LINK_HEIGHT} />;
    $[8] = onWorkspaceClick;
    $[9] = sdbCompany;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t8) {
    t9 = <Grid sx={t6} size={t7}>{t8}</Grid>;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}